module.exports = __webpack_public_path__ + "img/CECA_CD4Tconv.502481fd.png";